// extracted by mini-css-extract-plugin
export default {"graph":"Graph_graph__fLaxj"};